export enum VIDEO_ACTIONS {
    SET_BRAND_KIT_ID = 'SET_BRAND_KIT_ID',
}
